import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pushNotification: {
    title: '',
    body: '',
    show: false,
  },
  pushNotificationPermission: {
    token: '',
    permission: false,
  },
  permission: '',
  dialogs: {
    showPushPermissionModal: false,
  },
};

const pushNotificationSlice = createSlice({
  name: 'pushNotification',
  initialState,
  reducers: {
    openPushNotificationDialogs(state, action) {
      state.dialogs[action.payload] = true;
    },
    closePushNotificationDialogs(state, action) {
      state.dialogs[action.payload] = false;
    },
    setPushNotification(state, action) {
      state.pushNotification = action.payload;
    },
    setPushNotificationPermission(state, action) {
      state.pushNotificationPermission = action.payload;
    },
    setPermission(state, action) {
      state.permission = action.payload;
    },
  },
});

export const {
  setPushNotification,
  openPushNotificationDialogs,
  closePushNotificationDialogs,
  setPermission,
} = pushNotificationSlice.actions;

export default pushNotificationSlice.reducer;
